// extracted by mini-css-extract-plugin
export default {"difficultyCard":"DifficultyCard_difficultyCard__psKLb","fadeIn":"DifficultyCard_fadeIn__mKIMz"};